import { Container, Stack, SxProps } from "@mui/material";
import { useSearch } from "@tanstack/react-router";
import Page from "src/components/Page";
import useResponsive from "src/hooks/useResponsive";

import ThemeContext from "../context";
import useGetLinkTheme from "../hooks/useGetLinkTheme";
import useSetLinkLang from "../hooks/useSetLinkLang";
import useProductActionsStore from "../store";
import ConnectAccountCard from "./ConnectAccountCard";
import Context, { ContextType } from "./context";

// ----------------------------------------------------------------------

export type ConnectAccountParams = {
	id: string;
	themeType: string;
	locale: string;
	updateToken: string;
	restoreToken: string;
	authToken: string;
	externalId: string;
	isFrame: boolean;
	newLogin: boolean;
	entity?: string;
	backgroundColor?: string;
	primaryColor?: string;
	contentBackgroundColor?: string;
};

// ----------------------------------------------------------------------

const containerSx: SxProps = {
	height: "100vh",
	display: "flex",
	justifyContent: "center"
};

const stackSx: SxProps = {
	backgroundColor: "background.default",
	alignItems: "center",
	width: "100%"
};

type Props = {
	product?: string;
};

export const ConnectAccount = ({ product }: Props) => {
	const [state, actions] = useProductActionsStore();
	const { id, themeType, updateToken, externalId, isFrame, restoreToken }: ConnectAccountParams =
		useSearch({
			strict: false
		});

	const { theme } = useGetLinkTheme();
	useSetLinkLang();
	const isMobile = useResponsive("down", "sm");

	const context: ContextType = {
		updateToken,
		restoreToken,
		externalId,
		product
	};

	return (
		<Page title='Conectar cuenta'>
			<Container
				maxWidth={false}
				sx={{
					...containerSx,
					mt: isMobile ? 3 : 0,
					backgroundColor: theme?.colors.pageBackground,
					alignItems: isFrame || isMobile ? "flex-start" : "center"
				}}
			>
				<Stack sx={{ ...stackSx, backgroundColor: theme?.colors.pageBackground }}>
					<ThemeContext.Provider
						value={{ actions, state, id, themeType, theme, isFrame, product: product ?? "" }}
					>
						<Context.Provider value={context}>
							<ConnectAccountCard />
						</Context.Provider>
					</ThemeContext.Provider>
				</Stack>
			</Container>
		</Page>
	);
};

export default ConnectAccount;
